import { DOCUMENT } from '@angular/common';
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, UrlSerializer, withInMemoryScrolling } from '@angular/router';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { routes } from './app.routes';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { CustomUrlSerializer } from './services/custom-url-serializer';
import { TsHttpService } from './services/ts-http.service';
import { tsImageLoaderProvider } from './shared/picture/image-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({ includePostRequests: false }),
    ),
    tsImageLoaderProvider,
    provideAppInitializer(() => {
      inject(TsHttpService);
      const document = inject(DOCUMENT);
      const apiOrigin = new URL(TsHttpService.root).origin;
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = apiOrigin;
      document.head.appendChild(link);
    }),
  ],
};
